export default "__VITE_ASSET__DiUj_nTb__"